import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import vuetify from './plugins/vuetify'

require('ol/ol.css');
require('@/assets/styles/main.css')

Vue.config.productionTip = false

let vue = new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app')



